import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { Separator } from './ui/separator';
import aplenLogo from '../images/aplen_logo.png';

export default function Footer() {
  const footerLinks = {
    company: [
      { name: 'About', path: '/about' },
      { name: 'Our Business', path: '/our-business' },
      { name: 'Careers', path: '/careers' },
    ],
    compliance: [
      { name: 'Our Compliance', path: '/our-compliance' },
    ],
    resources: [
      { name: 'Contact Us', path: '/contact' },
    ],
  };

  // Combine all links for mobile view
  const allLinks = [
    ...footerLinks.company,
    ...footerLinks.compliance,
    ...footerLinks.resources
  ];

  return (
    <footer className="bg-slate-900 border-t border-border">
      <div className="container-custom py-6 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <img src={aplenLogo} alt="Apken Pharma" className="h-10 w-auto rounded-md" />
              <div className="font-bold text-xl text-white font-['Space_Grotesk']">Apken Pharma</div>
            </Link>
            <p className="text-white/90 text-sm leading-relaxed max-w-md">
              A pharmaceutical company committed to delivering high-quality, affordable medicines that improve patient outcomes globally.
            </p>
          </div>

          {/* Mobile Quick Links - Only show on small screens */}
          <div className="md:hidden lg:hidden">
            <h3 className="font-semibold text-white mb-4 font-['Space_Grotesk'] text-center">Quick Links</h3>
            <div className="flex flex-wrap justify-center gap-2 text-center">
              {allLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-sm text-white/80 hover:text-white transition-colors px-2"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Desktop Company Links - Hide on small screens */}
          <div className="hidden md:block lg:block">
            <h3 className="font-semibold text-white mb-4 font-['Space_Grotesk']">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Desktop Compliance Links - Hide on small screens */}
          <div className="hidden md:block lg:block">
            <h3 className="font-semibold text-white mb-4 font-['Space_Grotesk']">Compliance</h3>
            <ul className="space-y-3">
              {footerLinks.compliance.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Desktop Resources Links - Hide on small screens */}
          <div className="hidden md:block lg:block">
            <h3 className="font-semibold text-white mb-4 font-['Space_Grotesk']">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-white/80">
            © {new Date().getFullYear()} Apken Pharma. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
